import { PhotoIcon, XMarkIcon } from "@heroicons/react/20/solid";
import classes from "./classes.module.scss";
import Input from "components/materials/Form/InputElement";
import I18n from "components/materials/I18n";
import classNames from "classnames";
import { memo, useCallback, useRef, useState } from "react";
import LazyImage from "components/elements/LazyImage";

type IProps = {
	id: string;
	index: number;
	onRemove: (id: string) => void;
};

function VoteOptionInput(props: IProps) {
	const inputRef = useRef<HTMLInputElement>(null);
	const [image, setImage] = useState<File | null>(null);

	const onImageChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;
		setImage(file);
	}, []);

	const onAddImageClick = useCallback(() => {
		inputRef.current?.click();
	}, [inputRef]);

	const onRemove = useCallback(() => {
		props.onRemove(props.id);
	}, [props]);

	return (
		<div className={classes["root"]}>
			<div className={classNames(classes["icon-container"], classes["photo-icon-container"])} onClick={onAddImageClick}>
				{!image && <PhotoIcon className={classes["icon"]} />}
				{image && <LazyImage src={URL.createObjectURL(image)} alt="Vote option" className={classes["image"]} />}
				<input type="file" name={`option-image-${props.id}`} accept="image/*" ref={inputRef} onChange={onImageChange} hidden />
			</div>

			<Input
				name={`option-${props.id}`}
				className={classes["input"]}
				placeholder={I18n.trslt(I18n.asset.pages.professional_space.tabs.votes.create_vote_modal.vote_option_max_length, { index: (props.index + 1).toString() })}
			/>

			<div className={classes["icon-container"]} onClick={onRemove}>
				<XMarkIcon className={classes["icon"]} />
			</div>
		</div>
	);
}

export default memo(VoteOptionInput);
